import { render, staticRenderFns } from "./pretense_report_by_flat.vue?vue&type=template&id=d7f6980e&scoped=true&"
import script from "./pretense_report_by_flat.vue?vue&type=script&lang=js&"
export * from "./pretense_report_by_flat.vue?vue&type=script&lang=js&"
import style0 from "./pretense_report_by_flat.vue?vue&type=style&index=0&id=d7f6980e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f6980e",
  null
  
)

export default component.exports